import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TlkBannerComponent } from '@itero/ui-toolkit-angular/banner';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { TlkCheckboxComponent } from '@itero/ui-toolkit-angular/checkbox';
import { CloseEmptyIconComponent } from '@itero/ui-toolkit-angular/icons';

export interface BridgeBannerCloseEvent {
	dontShowAgain: boolean;
}

@Component({
	selector: 'rx-intuitive-bridge-banner',
	templateUrl: './rx-intuitive-bridge-banner.component.html',
	styleUrls: ['./rx-intuitive-bridge-banner.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule, TlkBannerComponent, TlkButtonComponent, TlkCheckboxComponent, CloseEmptyIconComponent]
})
export class RxIntuitiveTeethDiagramBridgeBannerComponent {
	@Output() closeEvent = new EventEmitter<BridgeBannerCloseEvent>();

	checkboxChecked = false;

	onCloseClicked(): void {
		this.closeEvent.emit({ dontShowAgain: this.checkboxChecked });
	}

	onDontShowAgainChanged(): void {
		this.checkboxChecked = !this.checkboxChecked;
	}
}
